import { fetchWrapper } from "../Helpers/fetch-wrapper";
import { toApiPage } from "./queryParams";

const getAllPacks = async (
  page,
  pageSize,
  sortBy,
  sortOrder,
  filters
) => {
  let params = [];
  if (page || page === 0) params.push("page=" + toApiPage(page));
  if (pageSize) params.push("pageSize=" + pageSize);
  if (sortBy) params.push("sortBy=" + sortBy);
  if (sortOrder) params.push("sortOrder=" + sortOrder);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        let param = "";
        param += `filters[${key}]=[`;
        let values = value.map((ele) => ele.id);
        values.join(",");
        param += values;
        param += `]`;
        params.push(param);
      } else if (typeof value == "string" && value) {
        params.push(`filters[${key}]=${value}`);
      }
    });
  }
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/temp_pack${
      params !== "" ? "?" + params.join("&") : ""
    }`
  );

  return response;
};

const getPackById = async (id) => {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/temp_pack/${id}`
  );
};

const createPack = async (params) => {
  const response = fetchWrapper.post(
    `${process.env.REACT_APP_API_ENDPOINT}/temp_pack`,
    { data: params?.data || params || {} }
  );
  return response;
};

const updatePack = async (id, params) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/temp_pack/${id}`,
    { data: params?.data || params || {} }
  );
  return response;
};

const deletePack = async (id) => {
  const response = fetchWrapper.delete(
    `${process.env.REACT_APP_API_ENDPOINT}/temp_pack/${id}`
  );
  return response;
};


const getUpload = async (id, upload) => {
  return fetchWrapper.post(
    `${process.env.REACT_APP_API_ENDPOINT}/temp_pack/${id}/getUpload`,
    {
      path: upload.path || undefined,
      disk: upload.disk || undefined
    }
  );
}

const saveUploads = async (id, uploads) => {
  let data = new FormData();
  for (const attribute in uploads) {
    if (attribute === 'existing_media') {
      data.append(attribute, JSON.stringify(uploads[attribute]));
    } else if (attribute === 'media_revision') {
      data.append(attribute, uploads[attribute]);
    } else {
      const files = Array.isArray(uploads[attribute]) ? uploads[attribute] : [uploads[attribute]];
      files.forEach((file) => data.append(attribute + '[]', file));
    }
  }

  return fetchWrapper.post(
    `${process.env.REACT_APP_API_ENDPOINT}/temp_pack/${id}/saveUpload`,
    data,
    true
  );
};


const packCount = async () => {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/temp-pack-count`
  );
}

export const DraftPackService = {
  getAllPacks,
  getPackById,
  createPack,
  updatePack,
  deletePack,
  getUpload,
  saveUploads,
  packCount,
};

